import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export default function SWUpdateToast() {
  const { toast } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    const handler = () => {
      toast({
        title: t('pwa.updateAvailable', 'Update beschikbaar!'),
        description: t('pwa.updateDescription', 'Er is een nieuwe versie van StudyBuddy.'),
        action: (
          <button
            onClick={() => {
              // Tell the waiting SW to skip waiting, which triggers controllerchange → reload
              navigator.serviceWorker.getRegistration().then((reg) => {
                reg?.waiting?.postMessage({ type: 'SKIP_WAITING' });
              });
            }}
            className="inline-flex items-center rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            {t('pwa.updateNow', 'Update nu')}
          </button>
        ),
        duration: Infinity,
      });
    };

    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, [toast, t]);

  return null;
}
